<template>
    <div class="flex w-full items-end sm:items-center justify-between sm:w-auto">
        <!-- самоидентификация -->
        <DropdownModal class="mr-3 sm:mr-6"
                       align="another"
                       width="60">
            <template #trigger>
                <button type="button"
                        class="btn_text_accent btn_transition flex_rounded"
                        style="margin-bottom: 1px;padding: 3px;"
                        v-tippy="'На этом видео есть Вы?'">
                    <span class="sm:mr-1"
                          v-html="collection.user_plus.path"></span>
                    Отметиться
                </button>
            </template>
			
            <template #content>
                <JoinContent :element="element"
                             style="z-index: 100;"/>
            </template>
        </DropdownModal>
		

        <CopyUrlToBuffer :url="page_url">
            <span class="sm:py-2.5 mr-3 sm:mr-6 relative flex_rounded btn_transition btn_text_accent">
                <span class="sm:mr-2"
                      v-html="collection.link_arrow.path"></span> Поделиться
            </span>
        </CopyUrlToBuffer>
		
        <JetDropdown align="right"
                     width="60"
                     v-if="element.article_id">
            <template #trigger>
                <button type="button"
                        class="self-end btn_padding btn_transition rounded-[10px] btn_border btn_text_accent">Материалы</button>
            </template>
			
            <template #content>
                <div class="py-4 px-[22px] flex flex-col gap-3 rounded-[10px] shadow-element min-w-[227px]">
                    <Link :href="'/library/article/'+element.article_id"
                          class="link_2 btn_transition">
                        <span v-html="collection.book.path"
                              class="mr-1">
                        </span>
                        Статья по видео
                    </Link>
                </div>
            </template>
        </JetDropdown>
	
    </div>
</template>
<script setup>
import { Link } from '@inertiajs/vue3';
import JetDropdown from '@/Components/Dropdown.vue';
import DropdownModal from '@/Components/DropdownModal.vue';
import JoinContent from '@/Pages/Videos/Components/JoinContent.vue';
import { icons as collection } from '@/shared/assets.js';
import CopyUrlToBuffer from '@/shared/CopyUrlToBuffer.vue';
import {onMounted, ref} from 'vue';

defineProps(['element']);
let page_url = ref('');
onMounted(() => {
    page_url.value = window.location.href;
});
</script>
<style>
.link_2 {
	@apply flex flex-wrap items-center text-main-secondary text-sm font-semibold  hover:text-main-accent after:content-[''] after:block after:w-full after:h-[1px] after:bg-main-shade after:mt-3
}
.btn_padding {
	@apply px-2 sm:px-4 py-1.5 sm:py-2.5
}
.btn_transition {
	@apply ease-out duration-300 transition-colors
}
.btn_border {
	@apply border border-main-accent hover:border-main-shade
}
.btn_text_accent {
	@apply text-sm font-medium text-main-accent
}
.flex_rounded {
	@apply flex items-center flex-col sm:flex-row rounded-[10px]
}
</style>